import { Stack } from 'components';
import aiScribeTranscribingBackground from 'assets/png/aiScribeTranscribingBackground.png';

import style from './transcribingScreen.module.scss';

const TranscribingScreen = () => {
  return (
    <Stack height="100%" width="100%">
      <img src={aiScribeTranscribingBackground} className={style.backgroundIntro}></img>
      <Stack
        position="relative"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100%"
      >
        <h2 className={style.title}>AI Scribe</h2>
        <Stack
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="16px"
          pb="8px"
          width="100%"
        >
          <p className={style.description}>We're on it!</p>
          <p className={style.explanation}>Give us a few minutes to process your recording.</p>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TranscribingScreen;
